import React, { useCallback, useEffect, useRef, useState } from 'react';
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers';
import { DeleteEventCalendar, GetAccountEmployeeTimeEntryCustomFields, GetAccountWorkingDayType, gettimesheetData, updateCustomFieldFalg, updateEventFalg } from './CalendarSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { useTranslation } from 'react-i18next';
// import AddEventModal from './AddEventModal';
import timeLiveLogo from '../../assets/image/logo-Icon-timelive.svg'
import moment from 'moment';
import { GetCalendarEventsForNotification } from '../../common/GlobalSlice';
import { getValueFromResource } from '../../common/timeLiveFunction';

type Props = {
    position: { top: number; left: number } | any;
    event: any;
    presetStartTime: string;
    presetEndTime: string;
    IsEdit?: boolean;
    IsDelete?:boolean;
    onClose: () => void;
    onSave: (newEvent: any) => void;
    onOpenEditModal?: (event: any) => void;
    onOpenAddEventModal?: (event: any) => void;
};

const InternalEventPopover: React.FC<Props> = ({ position, event,IsEdit,IsDelete, onClose, onSave, presetStartTime, presetEndTime, onOpenEditModal, onOpenAddEventModal }) => {
    const AccountId = localStorage.getItem('accountId');
    const { accountFeatureList } = useAppSelector((state) => state.globalState);
    const showTimesheet = accountFeatureList?.some((item: any) => item?.Id === 'db17deb7-51a0-4400-bf3b-9094e01ef038') ?? false;
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const userEmailAddress = localStorage.getItem('userEmailAddress');
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [adjustedPosition, setAdjustedPosition] = useState(position);
    const currentDate = moment().format('YYYY-MM-DD')

    useEffect(() => {
        const popoverWidth = 300
        const popoverHeight = 200
        const margin = 10

        let { top, left } = position
        if (left + popoverWidth > window.innerWidth) {
            left = window.innerWidth - popoverWidth - margin
        }
        if (left < margin) {
            left = margin
        }

        if (top + popoverHeight > window.innerHeight + window.scrollY) {
            top = position.top - popoverHeight - 5
        }
        if (top < window.scrollY + margin) {
            top = window.scrollY + margin
        }

        setAdjustedPosition({ top, left })
    }, [position])

    const handleDelete = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "", 'Yes delete it!', 'custom-swal-container')
            .then((result: any) => {
                if (result && event?.id) {
                    if (typeof onSave === 'function') {
                        onSave({ type: 'delete', id: event.id });
                    }
                    // dispatch(DeleteEventCalendar(event.id));
                    dispatch(DeleteEventCalendar(event.id))
                        .unwrap()
                        .then(() => {
                            dispatch(updateEventFalg(true));
                            if (moment(event?.start).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                                dispatch(GetCalendarEventsForNotification(currentDate));
                            }
                        });
                    dispatch(updateEventFalg(true));
                    // if (moment(event?.start).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                    //     dispatch(GetCalendarEventsForNotification(currentDate))
                    // }
                }
            });
        onClose();
    };

    const handleEditClick = () => {
        if (onOpenEditModal) {
            onOpenEditModal(event);
        }
        onClose();
    };

    const handleTimeEntryModal = () => {
        const currentDate = moment(event?.start).format('YYYY-MM-DD');
        const endDate = moment(event?.end ?? event?.start).format('YYYY-MM-DD');
        const obj = { AccountEmployeeId, currentDate, endDate }
        dispatch(gettimesheetData(obj))
        dispatch(GetAccountEmployeeTimeEntryCustomFields())
        dispatch(GetAccountWorkingDayType());
        dispatch(updateCustomFieldFalg(true));
        if (onOpenAddEventModal) {
            onOpenAddEventModal(event);
        }
        onClose();
    }

    const handlePopoverClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div
            style={{
                position: 'absolute',
                top: adjustedPosition?.top + 40,
                left: adjustedPosition?.left,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                width: '300px',
                zIndex: 9999,
                transition: "top 0.2s ease, left 0.2s ease",
            }}
            // onClick={(e) => e.stopPropagation()}
            onClick={handlePopoverClick}
            onMouseDown={handlePopoverClick}
        >
            <div
                className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom"
                style={{ backgroundColor: '#FFF', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
            >
                <div className="d-flex align-items-center gap-3">
                    {IsEdit && <i className="bi bi-pencil-square fs-5 iconColor allign cursor-pointer"
                        data-tooltip-id="tooltip-InternalEvent"
                        data-tooltip-content={getValueFromResource('Edit Event', dispatch, t)}
                        onClick={handleEditClick}
                    ></i>}
                    {showTimesheet && (
                        <i className="bi bi-clock fs-5 cursor-pointer iconColor"
                            data-tooltip-id="tooltip-InternalEvent"
                            data-tooltip-content={getValueFromResource('Save as time entry', dispatch, t)}
                            onClick={handleTimeEntryModal}
                        ></i>
                    )}
                   {IsDelete && <i className="bi bi-trash fs-5 delete-menu-icon-color allign cursor-pointer"
                        data-tooltip-id="tooltip-InternalEvent"
                        data-tooltip-content={getValueFromResource('Delete', dispatch, t)}
                        onClick={handleDelete}
                    ></i>}
                </div>

                <button
                    className="btn btn-sm btn-icon btn-light"
                    onClick={onClose}
                    style={{ border: 'none' }}
                >
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                </button>
            </div>

            <div className="p-3">
                {/* <div className="bg-success bg-opacity-10 text-success px-4 py-2 rounded text-center fw-semibold mb-3">
                    {event?.title}
                </div> */}
                <div className="px-4 py-2 rounded text-center fw-semibold mb-3" style={{ background: '#ede9fe', color: '#4c1d95' }}>
                    {event?.title}
                </div>
                <div className="d-flex gap-2 mx-auto" style={{ width: 'max-content' }}>
                    <div className="d-flex flex-column align-items-start my-2">
                        <div className='my-2'>
                            <span
                                className="bg-success rounded-circle"
                                style={{ width: '10px', height: '10px' }}
                            ></span>
                            <span className="fw-bold text-dark">{userEmailAddress}</span>
                        </div>
                        <div className='d-flex align-items-center gap-2 text-muted'>
                            <i className="bi bi-clock"></i>
                            <span>
                                {new Date(event.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} →
                                {' '}
                                {new Date(event.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </span>
                        </div>
                    </div>
                    <div>
                        <img
                            alt='Logo'
                            src={timeLiveLogo}
                            width={40}
                            height={40}
                            style={{ marginLeft: '8px', position: 'relative', top: '15px' }}
                        />
                    </div>
                </div>
            </div>

            <ReactTooltip
                id="tooltip-InternalEvent"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000
                }}
                place="top"
            />

            {/* {isShowTimeEntryModal &&
                <AddEventModal modelRef={modelRef} t={t} clickedDate={clickedDate} selectedEvent={event}
                    oncloseModal={() => {
                        closeModalAddEvent();
                    }}
                    onSave={(newEvent: any) => {
                        setSelectedEvent('')
                    }}
                    presetStartTime={presetStartTime}
                    presetEndTime={presetEndTime}
                />
            } */}
        </div>
    );
};

export default InternalEventPopover;
